import { render, staticRenderFns } from "./OnlineDocument.vue?vue&type=template&id=0fd34215&scoped=true"
import script from "./OnlineDocument.vue?vue&type=script&lang=js"
export * from "./OnlineDocument.vue?vue&type=script&lang=js"
import style0 from "./OnlineDocument.vue?vue&type=style&index=0&id=0fd34215&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd34215",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd34215')) {
      api.createRecord('0fd34215', component.options)
    } else {
      api.reload('0fd34215', component.options)
    }
    module.hot.accept("./OnlineDocument.vue?vue&type=template&id=0fd34215&scoped=true", function () {
      api.rerender('0fd34215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/OnlineDocument.vue"
export default component.exports